import React from 'react';
// styles
import styled, { css } from 'styled-components';
// state

const SoFormHeaderButtonText = styled.div`
  height: 16px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: var(--grey500);
  ${(props) =>
    !!props.step.isSelected &&
    css`
      color: var(--primary500);
    `};
`;

const SoFormHeaderButton = ({ className, step }) => (
  <button className={className}>
    {step.icon}
    <SoFormHeaderButtonText step={step}>{step.text}</SoFormHeaderButtonText>
  </button>
);

const regularCSS = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 16px;
  gap: 8px;
  width: 147px;
  height: 64px;
  background: var(--white);
  border: none;
  border-bottom: 4px solid var(--grey500);
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  svg {
    width: 24px;
    height: 24px;
    flex: none;
    order: 0;
    flex-grow: 0;
    fill: var(--grey500);
    path {
      fill: var(--grey500) !important;
    }
  }
  ${(props) =>
    !!props.step.isSelected &&
    css`
      border-bottom-color: var(--primary500);
      svg {
        fill: var(--primary500);
        path {
          fill: var(--primary500) !important;
        }
      }
    `};
`;

export default styled(SoFormHeaderButton)`
  ${regularCSS}
`;
